import { handleActions } from 'redux-actions';
import TransactionType from '../types/TransactionType';

const initialState = {
  transaction: {
    idDeposit: '',
    idMerchant: '',
    externalId: '',
    status: '',
  },
  installmentsReleases: {},
  extraInfo: {},
  statusHistory: [],
  logDetails: {},
  logDetailsLoading: false,
  statusHistoryLoading: false,
  extraInfoLoading: false,
};

export const TransactionDetails = handleActions(
  {
    [TransactionType.actions.fetchTransactionDetailsSuccess]: (currentState, { payload }) => ({ ...currentState, ...payload }),
    [TransactionType.actions.fetchTransactionHistorySuccess]: (currentState, { payload }) => ({ ...currentState, ...payload, statusHistoryLoading: false }),
    [TransactionType.actions.fetchExtraInfoSuccess]: (currentState, { payload }) => ({ ...currentState, ...payload, extraInfoLoading: false }),
    [TransactionType.actions.fetchExtraInfoLoading]: (currentState, { payload }) => ({ ...currentState, extraInfoLoading: payload }),
    [TransactionType.actions.fetchLogDetailsSuccess]: (currentState, { payload }) => ({ ...currentState, ...payload, logDetailsLoading: false }),
    [TransactionType.actions.fetchLogDetailsLoading]: (currentState, { payload }) => ({ ...currentState, logDetailsLoading: payload }),
    [TransactionType.actions.fetchTransactionHistoryLoading]: (currentState, { payload }) => ({ ...currentState, statusHistoryLoading: payload }),
    [TransactionType.actions.fetchInstallmentsReleasesSuccess]: (currentState, { payload }) => ({ ...currentState, installmentsReleases: payload }),
  },
  initialState
);

export const getTransactionDetails = (state) => {
  const { TransactionDetails } = state;
  return TransactionDetails.transaction;
};

export const getTransactionMerchantId = (state) => {
  const { TransactionDetails } = state;
  return TransactionDetails.transaction.idMerchant;
};

export const getStatusHistory = (state) => {
  const { TransactionDetails } = state;

  return TransactionDetails.statusHistory;
};

export const getExtraInfo = (state) => {
  const { TransactionDetails } = state;
  return TransactionDetails.extraInfo;
};

export const getLogDetails = (state) => {
  const { TransactionDetails } = state;
  return TransactionDetails.logDetails;
};

export const getLogDetailsLoading = (state) => {
  const { TransactionDetails } = state;
  return TransactionDetails.logDetailsLoading;
};

export const getStatusHistoryLoading = (state) => {
  const { TransactionDetails } = state;
  return TransactionDetails.statusHistoryLoading;
};

export const getInstallmentsReleases = (state) => {
  const { TransactionDetails } = state;
  return TransactionDetails.installmentsReleases;
};
